import { Link } from '@tanstack/react-router';
import { UserIcon } from 'lucide-react';

import { useMeQuery } from '@/query/auth';

import './profile-link.scss';

function hashToHue(input: string): number {
  let hash = 0;
  for (let i = 0; i < input.length; i++) {
    hash = (hash << 5) - hash + input.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash) % 360;
}

function getInitials(email: string): string {
  const local = email.split('@')[0] ?? '';
  const cleaned = local.replace(/[^A-Za-z0-9]/g, '');
  return cleaned.slice(0, 2).toUpperCase() || '??';
}

function ProfileLink() {
  const { data, isLoading, isError } = useMeQuery();

  if (isLoading || isError || !data) {
    return (
      <Link
        to={'/profile' as never}
        title="Profile"
        className="profile-link profile-link--fallback"
        data-testid="profile-link-fallback"
      >
        <UserIcon size={20} />
      </Link>
    );
  }

  const initials = getInitials(data.email);
  const hue = hashToHue(data.email);

  return (
    <Link
      to={'/profile' as never}
      title="Profile"
      className="profile-link"
      style={{ backgroundColor: `hsl(${String(hue)} 60% 45%)` }}
      activeProps={{ className: 'profile-link is-active' }}
    >
      <span className="profile-link__initials">{initials}</span>
    </Link>
  );
}

export { ProfileLink };
